var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isFetching
    ? _c("div", [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "select is-multiple" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.transfer,
                      expression: "transfer",
                    },
                  ],
                  attrs: { multiple: "", size: "12" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.transfer = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.transferable, function (dashboard) {
                  return _c(
                    "option",
                    { key: dashboard.id, domProps: { value: dashboard } },
                    [_vm._v(" " + _vm._s(dashboard.name) + " ")]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c("div", { staticClass: "column is-2" }, [
            _c(
              "button",
              {
                staticClass:
                  "button is-fullwidth is-dailycare is-outlined transfer-layout",
                attrs: { disabled: !_vm.transfer.length },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.transferDashboards.apply(null, arguments)
                  },
                },
              },
              [
                _c("dc-icon", {
                  attrs: {
                    icon: "chevron-double-right",
                    library: "fas",
                    "no-margin": "",
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "column" }, [
            _c(
              "div",
              {
                staticClass: "box dashboard-holder",
                class: { "empty-state": !_vm.myFields.length },
              },
              [
                _c(
                  "draggable",
                  {
                    attrs: {
                      list: _vm.myValue,
                      group: { draggable: ".key-feature" },
                    },
                    on: { end: _vm.end },
                  },
                  _vm._l(_vm.myFields, function (_name, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "box key-feature" },
                      [
                        _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column is-narrow" }, [
                            _c(
                              "span",
                              { staticClass: "dragger" },
                              [
                                _c("dc-icon", {
                                  attrs: { icon: "bars", "no-margin": "" },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "column" }, [
                            _vm._v(" " + _vm._s(_vm.layoutName(index)) + " "),
                          ]),
                          _c("div", { staticClass: "column is-narrow" }, [
                            _c(
                              "span",
                              {
                                staticClass: "delete-item",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.removeFeature(index)
                                  },
                                },
                              },
                              [
                                _c("dc-icon", {
                                  attrs: { icon: "times", "no-margin": "" },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                !_vm.myFields.length
                  ? _c("div", [
                      _vm._m(0),
                      _c("p", [_vm._v("From the options to the left")]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Add a layout to this user")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }